import moment from 'moment'
import { useEffect, useState } from 'react'
import { Button, Form, Modal, Row } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import DatePickerComponent from '../../Input/DatePicker'

function UpdateCoa(props) {
  const { detailCoa } = props
  const [data, setData] = useState({
    ...detailCoa
  })
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  useEffect(() => {
    if (detailCoa) {
      setData({
        ...detailCoa
      })
    }
  }, [detailCoa])

  const handleChangeInput = (e, value = null) => {
    setData((prevData) => ({ ...prevData, [e]: value }))
  }

  const handleSubmit = async () => {
    try {
      setLoadingSubmit(true)
      const body = {
        coa_pd: moment(data.coa_pd).format('YYYY-MM-DD'),
        coa_ed: moment(data.coa_ed).format('YYYY-MM-DD'),
        label_ed: data.label_ed
          ? moment(data.label_ed).format('YYYY-MM-DD')
          : '',
        label_pd: data.label_pd
          ? moment(data.label_pd).format('YYYY-MM-DD')
          : ''
      }

      const res = await api.post(`/inbound/pr-draft/coa/${data.id}`, body)

      if (res.data.success) {
        Common.showPopUpSuccessMessage(res.data.message)
        props.onHide()
        props.refreshdata()
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  const handleReset = () => {
    setData((prevData) => ({
      ...prevData,
      ...detailCoa
    }))
    props.onHide()
  }

  const buttonSubmit = () => {
    if (loadingSubmit) {
      return {
        variant: 'secondary',
        disabled: true,
        className: 'text-white opacity-25'
      }
    }
    if (
      data?.coa_status === 'not_match' &&
      (!data.coa_pd || !data.coa_ed || !data?.label_pd || !data?.label_ed)
    ) {
      return {
        variant: 'secondary',
        disabled: true,
        className: 'text-white opacity-25'
      }
    }
    return {
      variant: 'warning',
      disabled: false,
      className: 'text-white'
    }
  }

  return (
    <div>
      <Modal
        {...props}
        centered
        onHide={() => {
          handleReset()
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update COA</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="fw-bold">{detailCoa?.item?.item_name}</h5>
          <p>{detailCoa?.batch?.batch}</p>
          <Form>
            <Row>
              <DatePickerComponent
                label="md"
                name="coa_pd"
                value={data?.coa_pd}
                handleChange={handleChangeInput}
                col={6}
                disabled={data?.coa_status === 'not_match' ? false : true}
              />
              <DatePickerComponent
                label="ed"
                name="coa_ed"
                value={data?.coa_ed}
                handleChange={handleChangeInput}
                col={6}
                disabled={data?.coa_status === 'not_match' ? false : true}
              />
            </Row>
            {['match', 'not_match'].includes(data?.coa_status) && (
              <Row>
                <DatePickerComponent
                  label="md"
                  name="label_pd"
                  value={data?.label_pd}
                  handleChange={handleChangeInput}
                  col={6}
                  disabled={data?.coa_status === 'not_match' ? false : true}
                />
                <DatePickerComponent
                  label="ed"
                  name="label_ed"
                  value={data?.label_ed}
                  handleChange={handleChangeInput}
                  col={6}
                  disabled={data?.coa_status === 'not_match' ? false : true}
                />
              </Row>
            )}
            <Modal.Footer>
              <Button {...buttonSubmit()} onClick={handleSubmit}>
                {loadingSubmit ? 'Saving...' : 'Save'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default UpdateCoa
